import {NgModule} from "@angular/core";
import {FormsModule} from "@angular/forms";
import {SendXrefButtonComponent} from "./send-xref-button.component";
import { RouterModule } from '@angular/router';
import {CommonModule} from '@angular/common';
import { SelectRequestModalComponent } from "../select-request-modal/select-request-modal.component";
import { PlanService } from "src/app/services/plan-status/plan-status.service";
import {ButtonModule, ProductToggleModule} from "@xref/xref-lib";
@NgModule({
  declarations: [
    SendXrefButtonComponent,
    SelectRequestModalComponent
  ],
  imports: [
    RouterModule,
    FormsModule,
    CommonModule,
    ProductToggleModule,
    ButtonModule
  ],
  exports: [SendXrefButtonComponent]
})
export class SendXrefButtonModule {
}
